const CONTRIBUTION_KEY = 'social_collage_contribution';

export function saveContribution(contribution) {
  sessionStorage.setItem(CONTRIBUTION_KEY, JSON.stringify(contribution));
}

export function readContribution() {
  try {
    const value = JSON.parse(sessionStorage.getItem(CONTRIBUTION_KEY) || 'null');
    if (!value || typeof value.photo !== 'string') return null;
    return {
      photo: value.photo,
      message: typeof value.message === 'string' ? value.message : '',
      ticketId: typeof value.ticketId === 'string' ? value.ticketId : '',
      username: typeof value.username === 'string' ? value.username : '',
      orientation: value.orientation === 'landscape' ? 'landscape' : 'portrait',
    };
  } catch {
    return null;
  }
}

export function clearContribution() {
  try {
    sessionStorage.removeItem(CONTRIBUTION_KEY);
  } catch {
    /* ignore */
  }
}
